
import { useState } from 'react';
import { observer } from 'mobx-react';
import { FiChevronDown } from 'react-icons/fi';
import { Anchor } from '@strategies/react-anchors';
import { henshu, useHenshu } from '@strategies/henshu';
import { useHenshuApp } from '@strategies/henshu-app';

import NavSection from '../NavSection';
import { ENGAGEMENT_LINK } from '../../config';
const ENGAGEMENT_LINKS = [
    'https://sasaki.sharefile.com/public/share/web-s78dab96e8ba041c3bf4c8579372b8497',
    'https://sasaki.sharefile.com/public/share/web-s0bd883b2c0f84ea6b5ebeb429fa8d984'
];

export default observer(function Welcome() {
    const { bindTo } = useHenshu();
    const [promptHidden, setPromptHidden] = useState(false);
    const { persist, isEditing } = useHenshuApp();
    return (
        <div className="Welcome-wrap">
            <NavSection name="Welcome" index={0}>
                <Anchor onChange={(anchor) => setPromptHidden(anchor.placement === 'offscreen')} />
                <div className='logo'></div>
                <div className='link-info'><henshu.richtext {...bindTo('enegage.calendar.infobodyupdate')} /></div>
                <div className="links">




                    <henshu.a
                        className="button with-arrow"
                        href={ENGAGEMENT_LINKS[0]}
                        target={"_blank"}
                        {...bindTo('enegage.welcome.button.plansummary')}
                    />
                    <henshu.a
                        className="button with-arrow"
                        href={ENGAGEMENT_LINKS[1]}
                        target={"_blank"}
                        {...bindTo('enegage.welcome.button.fullreport')}
                    />
                    </div>
            </NavSection>

            <footer
                className={promptHidden ? 'hidden' : ''}
                onClick={() => window.scrollTo({ top: window.innerHeight - 100, left: 0, behavior: 'smooth' })}
            >
                <FiChevronDown />
            </footer>
        </div>
    );
});
